import {
  branch,
  compose,
  lifecycle,
  renderComponent,
  renderNothing,
  setPropTypes,
  withHandlers,
} from 'recompose';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Spinner from '../../../../common/Spinner';
import PaymentList from '../components/PaymentList';
import { deletePaymentCard, fetchPaymentCard, setDefaultCard } from '../../../payment/actions';

const PaymentListContainer = compose(
  setPropTypes({
    setCards: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    setFetching: PropTypes.func.isRequired,
    removeCard: PropTypes.func.isRequired,
    updateDefaultCard: PropTypes.func.isRequired,
  }),
  connect(
    null,
    { fetchPaymentCard, deletePaymentCard }
  ),
  lifecycle({
    componentDidMount() {
      this.props.setFetching(true);
      this.props.fetchPaymentCard(this.props.customerId)
        .then((cards) => {
          this.props.setFetching(false);
          this.props.setCards(cards);
        })
        .catch(() => this.props.setFetching(false));
    },
  }),
  withHandlers({
    onCardDelete: props => cardId => () => {
      props.setFetching(true);
      deletePaymentCard(props.customerId, cardId)
        .then(() => {
          props.setFetching(false);
          props.removeCard(cardId);
        })
        .catch(() => props.setFetching(false));
    },
    onSetDefault: props => card => () => {
      props.setFetching(true);
      setDefaultCard(props.customerId, card.id)
        .then(() => {
          props.setFetching(false);
          props.updateDefaultCard({ ...card, isDefault: true });
        })
        .catch(() => props.setFetching(false));
    },
    isSelected: props => item => props.canSelect && item.paymentCardId === props.selectedCardId,
    isDefaultSelected: props => item => props.canChangeDefault && item.isDefault,
  }),
  branch(
    props => props.fetching,
    renderComponent(Spinner),
  ),
  branch(
    props => isEmpty(props.cards),
    renderNothing,
  ),
)(PaymentList);

export default PaymentListContainer;
